import { Injectable } from '@angular/core';
import { AuthenticationService } from '../authentication/authentication.service';
import { HttpClient } from '@angular/common/http';
import { LoggingService } from '../logging/logging.service';
import { TreeNode } from 'primeng/primeng';

@Injectable()
export class SearchService {
  downloadUrl: string;
  constructor(private http: HttpClient,
    private auth: AuthenticationService,
    private logging: LoggingService) {
    this.downloadUrl = `${this.auth.apiUrl}/api/storage/download`;
   }

  public searchFiles(searchModel) {
    return this.http.post(`${this.auth.apiUrl}/api/storage/search`, searchModel, { headers: this.auth.header })
      .toPromise()
      .then( response => response )
      .catch(error => this.logging.handleError(error));
  }
}



// WEBPACK FOOTER //
// ./src/app/services/search/search.service.ts